import {Template} from "../interfaces/templates";

const fakeTemplates: Template[] = [
    {
        id: 1,
        title: "Double Column",
        imagePath: "https://enhancv.com/static/d6817bb5bdf95721c52409c6ce6ccbcb/01a89/DoubleColumn_1.webp",
        content: ""
    }, {
        id: 2,
        title: "Elegant",
        imagePath: "https://enhancv.com/static/9e80d5bf5d00be20e797d2fb56a35d80/01a89/SingleColumn_1.webp",
        content: ""
    },
    {
        id: 3,
        title: "Modern",
        imagePath: "https://enhancv.com/static/07583b0ea0e2b244c79a48209774463d/01a89/Modern_1.webp",
        content: ""
    }, {
        id: 4,
        title: "Creative",
        imagePath: "https://enhancv.com/static/b2d15bf1e50a7cd5f855239db0953864/01a89/Multicolumn_2.webp",
        content: ""
    }, {
        id: 5,
        title: "Timeline",
        imagePath: "https://enhancv.com/static/011a1437fe5ede1c4d3e37bf501285e0/01a89/Timeline_1.webp",
        content: ""
    }, {
        id: 6,
        title: "Classic",
        imagePath: "https://enhancv.com/static/413f8e57ab780be14d8365b0903d2583/01a89/Classic_1.webp",
        content: ""
    }, {
        id: 7,
        title: "Multicolumn",
        imagePath: "https://enhancv.com/static/b2d15bf1e50a7cd5f855239db0953864/01a89/Multicolumn_2.webp",
        content: ""
    }, {
        id: 8,
        title: "Compact",
        imagePath: "https://enhancv.com/static/cf9696332997f01b4c05587eb4e0892d/01a89/Compact_1.webp",
        content: ""
    }
]
export {
    fakeTemplates
}